module.exports = __webpack_public_path__ + "img/atuuta_ag_blue.6db07d06.svg";